/* eslint-disable */
import React, { Component } from 'react';
import Authorization from './Authorization'
class Index extends Component {

    render(){
        return this.props.visible && <Authorization {...this.props}/>
    }
}
export default Index